module.exports = __webpack_public_path__ + "static/media/electric.605a4ead.svg";